import "@hotwired/turbo-rails"
import '../modules/glider.min'
import '../modules/posthog'
import '../vendor/hs-unfold/hs-unfold';
require("app_shared");